export class TriageAction {

  constructor() {
    this.typeCode = null;
    this.parameters = null;
  }

  resetTypeCode() {
    this.isTypeArchive = false;
    this.isTypeTag = false;
    this.isTypeNotifyByEmail = false;
    this.isTypeNotifyTeamByEmail = false;
    this.isTypeSetVIP = false;
    this.isTypeRandomDispatch = false;
    this.isTypeRandomDispatchCurrentTask = false;
    this.isTypeReplyToPublicComment = false;
    this.isTypeHideOnFacebook = false;
  }

  initTypeCode (typeCode) {
    this.isTypeArchive = typeCode === _TYPE_CODES.ARCHIVE;
    this.isTypeTag = typeCode === _TYPE_CODES.TAG;
    this.isTypeNotifyByEmail = typeCode === _TYPE_CODES.NOTIFY_BY_EMAIL;
    this.isTypeNotifyTeamByEmail = typeCode === _TYPE_CODES.NOTIFY_TEAM_BY_EMAIL;
    this.isTypeSetVIP = typeCode === _TYPE_CODES.SET_VIP;
    this.isTypeRandomDispatch = typeCode === _TYPE_CODES.RANDOM_DISPATCH;
    this.isTypeRandomDispatchCurrentTask = typeCode === _TYPE_CODES.RANDOM_DISPATCH_CURRENT_TASK;
    this.isTypeReplyToPublicComment = typeCode === _TYPE_CODES.REPLY_TO_PUBLIC_COMMENT;
    this.isTypeHideOnFacebook = typeCode === _TYPE_CODES.HIDE_ON_FACEBOOK;
    this.isTypeReplyToPrivateMessage = typeCode === _TYPE_CODES.REPLY_TO_PRIVATE_MESSAGE;
  }
  
  setTypeCode(typeCode) {
    this.typeCode = typeCode;
    this.parameters = TriageActionType.forCode(typeCode).defaultParamsFn();

    this.resetTypeCode();
    // setTimeout is needed for change detection in the template in "action.isTypeRandomDispatch || action.isTypeRandomDispatchCurrentTask"
    setTimeout(() => {
      this.initTypeCode(typeCode);
    }, 0);
  }
  
  static fromBackEnd(backendAction) {
    const result = new TriageAction();
    result.typeCode = backendAction.typeCode;
    result.initTypeCode(result.typeCode);
    result.parameters = angular.copy(backendAction.parameters);
    return result;
  }
}


export class TriageActionType {

  constructor(code, defaultParamsFn) {
    this.code = code;
    this.defaultParamsFn = defaultParamsFn;
  }

  static codes() {
    return _TriageActionTypes.map(t => t.code);
  }

  static values() {
    return _TriageActionTypes;
  }

  static forCode(code) {
    return _TriageActionTypes.filter(t => t.code === code)[0];
  }
}

const _TYPE_CODES = {
  ARCHIVE: 'archive',
  TAG: 'tag',
  PROPAGATE_ROUTING_TAG_WO: 'propagate-routing-tag-without-overwriting',
  PROPAGATE_QUALIFYING_TAGS_WO: 'propagate-qualifying-tags-without-overwriting',
  NOTIFY_BY_EMAIL: 'notify-by-email',
  NOTIFY_TEAM_BY_EMAIL: 'notify-team-member',
  SET_VIP: 'set-vip',
  RANDOM_DISPATCH: 'random-dispatch',
  RANDOM_DISPATCH_CURRENT_TASK: 'set-random-tag-current-task',
  REPLY_TO_PUBLIC_COMMENT: 'reply-to-public-comment',
  HIDE_ON_FACEBOOK: 'hide-on-facebook',
  REPLY_TO_PRIVATE_MESSAGE: 'reply-to-private-message',
}

const _TriageActionTypes = [
  new TriageActionType(_TYPE_CODES.ARCHIVE,                      () => ({})), 
  new TriageActionType(_TYPE_CODES.TAG,                          () => ({'tagGroupId': null, 'tagId': null})),
  new TriageActionType(_TYPE_CODES.PROPAGATE_ROUTING_TAG_WO,     () => ({})),
  new TriageActionType(_TYPE_CODES.PROPAGATE_QUALIFYING_TAGS_WO, () => ({})),
  new TriageActionType(_TYPE_CODES.NOTIFY_BY_EMAIL,              () => ({'userId': null})),
  new TriageActionType(_TYPE_CODES.NOTIFY_TEAM_BY_EMAIL,         () => ({})),
  new TriageActionType(_TYPE_CODES.SET_VIP,                      () => ({})),
  new TriageActionType(_TYPE_CODES.RANDOM_DISPATCH,              () => ({'tagGroupId': null, 'tagIdsAndPercentages': []})),
  new TriageActionType(_TYPE_CODES.RANDOM_DISPATCH_CURRENT_TASK, () => ({'tagGroupId': null, 'tagIdsAndPercentages': []})),
  new TriageActionType(_TYPE_CODES.REPLY_TO_PUBLIC_COMMENT,      () => ({'messages': [null]})),
  new TriageActionType(_TYPE_CODES.HIDE_ON_FACEBOOK,             () => ({})),
  new TriageActionType(_TYPE_CODES.REPLY_TO_PRIVATE_MESSAGE,     () => ({'messages': [null]})),
];
